import { Component, OnInit } from '@angular/core';
import { environment } from './../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  windowWidth = 0;

  isShowOptions: boolean = true;

  constructor() { }

  ngOnInit(): void {
    if (environment.is_HTTPS_mandatory && window.location.href.startsWith('http:')) {
      window.location.href = window.location.href.replace('http:', 'https:');
    }
    this.windowWidth = window.innerWidth;

    if (window.location.href.indexOf('rv-print') > -1) {
      this.isShowOptions = false;
    }

    if (this.isShowOptions) {
      document.body.classList.add('show-options-page');
    } else {
      document.body.classList.add('hide-options-page');
    }
  }

  onResize(e) {
    this.windowWidth = window.innerWidth;
  }
}
